let audioContext = null

function getAudioContext() {
    if (!audioContext) audioContext = new (window.AudioContext || window.webkitAudioContext)()
    return audioContext
}

function playTone(frequency, duration, type = 'sine') {
    try {
        const ctx = getAudioContext()
        const osc = ctx.createOscillator()
        const gain = ctx.createGain()
        osc.connect(gain)
        gain.connect(ctx.destination)
        osc.frequency.value = frequency
        osc.type = type
        gain.gain.setValueAtTime(0.15, ctx.currentTime)
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration)
        osc.start(ctx.currentTime)
        osc.stop(ctx.currentTime + duration)
    } catch {
        // Ignore audio errors in restricted browser contexts.
    }
}

export function playSound(type) {
    if (typeof window === 'undefined') return
    const enabled = localStorage.getItem('kanbify_sounds') !== 'false'
    if (!enabled) return

    const sounds = {
        cardDrop: () => { playTone(440, 0.08); setTimeout(() => playTone(554, 0.06), 50) },
        check: () => playTone(660, 0.1, 'sine'),
        complete: () => {
            playTone(523, 0.08)
            setTimeout(() => playTone(659, 0.08), 80)
            setTimeout(() => playTone(784, 0.12), 160)
        },
        levelUp: () => {
            playTone(523, 0.1)
            setTimeout(() => playTone(659, 0.1), 100)
            setTimeout(() => playTone(784, 0.1), 200)
            setTimeout(() => playTone(1047, 0.2), 300)
        },
        // Small pleasant two-note ding for in-app notifications.
        notify: () => { playTone(880, 0.07); setTimeout(() => playTone(1175, 0.09), 70) },
    }
    const fn = sounds[type] || sounds.check
    fn()
}

export function setSoundsEnabled(enabled) {
    localStorage.setItem('kanbify_sounds', enabled ? 'true' : 'false')
}

export function getSoundsEnabled() {
    return localStorage.getItem('kanbify_sounds') !== 'false'
}
